/* CRAFT BANK 商品ページ（2026-10 第二弾）
   - 共通: 写真の切り替え、数量の±、下部の追従購入バー
   - 単品ビール: 購入方法モーダル（スマホはボトムシート）、スクロール時の案内（1セッション1回）
   - SELECT: 本数・合計額・6本単位の案内、おすすめ一括セット、カート追加
   カートへの追加は Shopify 標準の /cart/add（フォーム送信）と /cart/add.js のみ。追加後はカートページへ移動する（配達日時をカートで選ぶため）。 */
(() => {
  if (window.__cbPdp) return;
  window.__cbPdp = true;

  const yen = (cents) => '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
  const cartUrl = () => ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';

  const addToCart = async (items, msgEl) => {
    if (msgEl) msgEl.textContent = 'カートに追加しています…';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.description || data.message || 'カートに追加できませんでした。');
      }
      window.location.href = cartUrl();
    } catch (e) {
      if (msgEl) msgEl.textContent = e instanceof Error ? e.message : 'カートに追加できませんでした。';
      throw e;
    }
  };

  /* ---------- 写真の切り替え ---------- */
  const initGallery = (root) => {
    const main = root.querySelector('[data-cb-gallery-main]');
    // 切り替えはフェード（新しい写真を上に重ねて透明度を上げ、終わったら古い写真を外す）（2026-10-15）
    const show = (btn) => {
      if (btn.classList.contains('is-active')) return;
      const src = btn.getAttribute('data-cb-thumb');
      root.querySelectorAll('[data-cb-thumb]').forEach((b) => b.classList.toggle('is-active', b === btn));
      if (!main.querySelector('img')) main.innerHTML = '';
      const img = document.createElement('img');
      img.className = 'cbp-img cbp-fade';
      img.alt = '';
      img.src = src;
      main.appendChild(img);
      const reveal = () => {
        if (!img.isConnected) return;
        // 背景が透明な缶の写真でも重なって見えないよう、古い写真は同時に薄くする
        if (img.classList.contains('is-out')) return;
        void img.offsetWidth; // 透明度0の状態を一度確定させてから1にする（フェードさせるため）
        img.classList.add('is-in');
        [...main.querySelectorAll('img')].forEach((o) => { if (o !== img && o.compareDocumentPosition(img) & Node.DOCUMENT_POSITION_FOLLOWING) o.classList.add('is-out'); });
        setTimeout(() => {
          if (!img.isConnected || img.classList.contains('is-out')) return;
          [...main.querySelectorAll('img')].forEach((o) => { if (o !== img && o.compareDocumentPosition(img) & Node.DOCUMENT_POSITION_FOLLOWING) o.remove(); });
          img.classList.remove('cbp-fade', 'is-in');
        }, 450);
      };
      if (img.complete) reveal(); else img.addEventListener('load', reveal, { once: true });
    };
    // マウスのある端末は、小さい写真にカーソルを合わせただけで切り替える（2026-10-15）。タップ・クリックでも切り替わる
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const thumbs = [...root.querySelectorAll('[data-cb-thumb]')];
    let base = thumbs.find((b) => b.classList.contains('is-active')) || thumbs[0];
    thumbs.forEach((btn) => {
      btn.addEventListener('click', () => { base = btn; show(btn); });
      if (canHover) btn.addEventListener('mouseenter', () => { base = btn; show(btn); });
    });
    // 大きい写真にカーソルを乗せている間は次の写真を出し、外れたら元に戻す（2026-10-15 大地さん指示）
    if (canHover && main && thumbs.length > 1) {
      let preloaded = false;
      main.addEventListener('mouseenter', () => {
        if (!preloaded) { thumbs.forEach((b) => { new Image().src = b.getAttribute('data-cb-thumb'); }); preloaded = true; }
        show(thumbs[(thumbs.indexOf(base) + 1) % thumbs.length]);
      });
      main.addEventListener('mouseleave', () => show(base));
    }
  };

  /* ---------- 数量 ---------- */
  const initQty = (box) => {
    const input = box.querySelector('[data-cb-qinput]');
    const set = (n) => { input.value = String(Math.max(1, Math.min(99, n || 1))); };
    box.querySelector('[data-cb-qminus]').addEventListener('click', () => set(Number(input.value) - 1));
    box.querySelector('[data-cb-qplus]').addEventListener('click', () => set(Number(input.value) + 1));
    input.addEventListener('change', () => set(Number(input.value)));
  };

  /* ---------- 追従購入バー: 上部の購入ボタン（SELECT は集計の購入ボタン）が画面に見えていない間だけ出す ---------- */
  const initSticky = (main) => {
    const bar = main.querySelector('[data-cb-sticky]');
    if (!bar) return;
    // SELECT: 一覧（data-cb-sticky-after の要素）が画面の下から入ってきたら出し、上部に戻ったら隠す
    // セット等: 上部の購入ボタンが画面に見えていない間だけ出す
    const after = bar.dataset.cbStickyAfter ? document.querySelector(bar.dataset.cbStickyAfter) : null;
    const cta = main.querySelector('[data-cb-main-cta]');
    if (!after && !cta) return;
    let ticking = false;
    const update = () => {
      ticking = false;
      let show;
      if (after) {
        show = after.getBoundingClientRect().top < window.innerHeight * 0.8;
      } else {
        const r = cta.getBoundingClientRect();
        show = !(r.bottom > 0 && r.top < window.innerHeight);
      }
      bar.hidden = !show;
      document.documentElement.classList.toggle('cbp-has-sticky', show);
      if (show) document.documentElement.style.setProperty('--cbp-sticky-h', `${bar.offsetHeight}px`);
    };
    // 判定は位置の取得だけで軽いので、描画待ち（requestAnimationFrame）に頼らず短い間隔で直接行う
    const onScroll = () => { if (!ticking) { ticking = true; window.setTimeout(update, 60); } };
    // テーマや年齢確認の都合で window 以外がスクロールする場合もあるため、document で捕捉する
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
    // 画像の読み込みやページ内リンクで位置が変わったときも判定し直す
    window.addEventListener('load', update);
    window.addEventListener('hashchange', () => window.setTimeout(update, 120));
    const form = main.querySelector('[data-cb-form]');
    bar.querySelector('[data-cb-sticky-submit]')?.addEventListener('click', () => {
      if (!form) return;
      if (typeof form.reportValidity === 'function' && !form.reportValidity()) { cta.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
    });
  };

  /* ---------- 単品ビール: 購入方法モーダル ---------- */
  const initBeer = (root) => {
    const dialog = root.querySelector('[data-cb-buy-dialog]');
    if (!dialog) return;
    const PROMPT_KEY = 'cb-buy-prompt-shown';
    // 確認用: URL に ?cb_prompt=reset を付けると「表示済み」の記録を消す（実機での見え方の確認に使う）
    try { if (new URLSearchParams(window.location.search).get('cb_prompt') === 'reset') sessionStorage.removeItem(PROMPT_KEY); } catch (_) { /* 保存できなくても続ける */ }
    const markShown = () => { try { sessionStorage.setItem(PROMPT_KEY, '1'); } catch (_) { /* 保存できなくても動作は続ける */ } };
    const promptBox = root.querySelector('[data-cb-prompt-box]');

    const mini = root.querySelector('[data-cb-mini]');
    const hideMini = () => { if (mini) mini.hidden = true; document.documentElement.classList.remove('cbb-mini-open'); };
    const showMini = () => { if (!mini) return; mini.hidden = false; document.documentElement.classList.add('cbb-mini-open'); };
    mini?.querySelector('[data-cb-mini-close]')?.addEventListener('click', hideMini);
    const open = () => {
      hideMini();
      if (promptBox) promptBox.hidden = true;
      markShown();
      if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
      document.documentElement.classList.add('cbb-lock');
    };
    const close = () => { if (dialog.close) dialog.close(); else dialog.removeAttribute('open'); };
    dialog.addEventListener('close', () => document.documentElement.classList.remove('cbb-lock'));
    dialog.addEventListener('click', (e) => { if (e.target === dialog) close(); });
    dialog.querySelector('[data-cb-close]')?.addEventListener('click', close);
    document.addEventListener('click', (e) => {
      const t = e.target instanceof Element ? e.target.closest('[data-cb-open-buy]') : null;
      if (t) { e.preventDefault(); open(); }
    });

    // スクロールで「おすすめのペアリング」が画面に入ったら、小さな購入案内を1回だけ出す（1セッション1回。自分で開いた後は出さない）
    if (root.dataset.cbPrompt === 'true') {
      let shown = false;
      try { shown = sessionStorage.getItem(PROMPT_KEY) === '1'; } catch (_) { shown = false; }
      const anchor = root.querySelector('[data-cb-prompt-anchor]');
      if (!shown && anchor) {
        let ticking = false;
        const check = () => {
          ticking = false;
          if (shown) return;
          try { if (sessionStorage.getItem(PROMPT_KEY) === '1') { shown = true; return; } } catch (_) { /* 保存できなくても続ける */ }
          if (anchor.getBoundingClientRect().top < window.innerHeight * 0.6 && !dialog.open) {
            shown = true;
            markShown();
            if (mini) showMini(); else open();
          }
        };
        const onScroll = () => { if (!ticking) { ticking = true; window.setTimeout(check, 120); } };
        document.addEventListener('scroll', onScroll, { passive: true, capture: true });
      }
    }
  };

  /* 購入方法からセットを直接カートへ */
  document.addEventListener('click', (e) => {
    const btn = e.target instanceof Element ? e.target.closest('[data-cb-add]') : null;
    if (!btn) return;
    e.preventDefault();
    const msg = btn.closest('dialog, .cbp-buypanel, .cbb-mini')?.querySelector('[data-cb-msg]') || null;
    btn.setAttribute('disabled', '');
    addToCart([{ id: Number(btn.getAttribute('data-cb-add')), quantity: 1 }], msg).catch(() => btn.removeAttribute('disabled'));
  });

  /* ---------- SELECT ---------- */
  const initSelect = (root) => {
    const unit = Number(root.dataset.unit) || 6;
    const items = [...root.querySelectorAll('[data-cb-sel-item]')];
    const state = new Map(items.map((el) => [el, 0]));
    const all = (sel) => document.querySelectorAll(sel);
    const emptyMsg = document.querySelector('[data-cb-sel-msg]')?.dataset.empty || '1本から選べます。6本単位がおすすめです。';

    const render = () => {
      let count = 0; let total = 0;
      items.forEach((el) => {
        const q = state.get(el);
        const max = Number(el.dataset.max) || 0;
        count += q; total += q * Number(el.dataset.price);
        el.querySelector('[data-cb-qty]').textContent = String(q);
        el.querySelector('[data-cb-dec]').disabled = q <= 0;
        el.querySelector('[data-cb-inc]').disabled = q >= max;
        el.classList.toggle('is-picked', q > 0);
      });
      if (render.last !== undefined && render.last !== count) {
        all('[data-cb-sel-bump]').forEach((n) => { n.classList.remove('is-bump'); void n.offsetWidth; n.classList.add('is-bump'); });
      }
      render.last = count;
      const rest = count % unit;
      let msg; let short;
      if (count === 0) { msg = emptyMsg; short = emptyMsg; }
      else if (rest === 0) { msg = `${count}本（${count / unit}箱）。まだ追加できます。${count + unit}本で${count / unit + 1}箱です。`; short = msg; }
      else { msg = `あと${unit - rest}本で${count + unit - rest}本。${unit}本単位がおすすめです。`; short = `あと${unit - rest}本で${count + unit - rest}本`; }
      all('[data-cb-sel-count]').forEach((n) => { n.textContent = String(count); });
      all('[data-cb-sel-total]').forEach((n) => { n.textContent = yen(total); });
      all('[data-cb-sel-msg]').forEach((n) => { n.textContent = msg; n.classList.toggle('is-on', count > 0); });
      all('[data-cb-sel-msg-short]').forEach((n) => { n.textContent = short; });
      all('[data-cb-sel-buy]').forEach((b) => { b.disabled = count === 0; });
      // 丸印は1行＝1箱（unit本）で折り返して縦に積む。2行（12本）を超えた分は「＋◯本」と文字で添える
      const MAX_DOTS = unit * 2;
      all('[data-cb-sel-dots]').forEach((dots) => {
        // 6本・12本…の区切りに達したら、次の箱の空の丸印を1行先に見せて「まだ選べる」ことを伝える
        const slots = Math.max(unit, Math.ceil((count + 1) / unit) * unit);
        dots.innerHTML = '';
        for (let i = 0; i < Math.min(slots, MAX_DOTS); i += 1) {
          const d = document.createElement('span');
          if (i < count) d.className = 'on';
          dots.appendChild(d);
        }
        if (count > MAX_DOTS) {
          const more = document.createElement('em');
          more.textContent = `＋${count - MAX_DOTS}本`;
          dots.appendChild(more);
        }
      });
      // 丸印の行数でバーの高さが変わるので、上部へ戻るボタンの位置・下余白を合わせ直す
      const bar = document.querySelector('[data-cb-sticky]');
      if (bar && !bar.hidden) document.documentElement.style.setProperty('--cbp-sticky-h', `${bar.offsetHeight}px`);
    };

    items.forEach((el) => {
      el.querySelector('[data-cb-inc]').addEventListener('click', () => { state.set(el, Math.min(state.get(el) + 1, Number(el.dataset.max) || 0)); render(); });
      el.querySelector('[data-cb-dec]').addEventListener('click', () => { state.set(el, Math.max(state.get(el) - 1, 0)); render(); });
    });

    const byHandle = (h) => items.find((el) => el.dataset.handle === h);
    root.querySelectorAll('[data-cb-combo]').forEach((btn) => {
      btn.addEventListener('click', () => {
        items.forEach((el) => state.set(el, 0));
        btn.getAttribute('data-cb-combo').split(',').forEach((pair) => {
          const [h, q] = pair.split(':');
          const el = byHandle(h);
          if (el) state.set(el, Math.min(Number(q) || 0, Number(el.dataset.max) || 0));
        });
        render();
      });
    });

    const pre = new URLSearchParams(window.location.search).get('beer');
    const preEl = pre ? byHandle(pre) : null;
    if (preEl && Number(preEl.dataset.max) > 0) state.set(preEl, 1);

    const msgEl = document.querySelector('[data-cb-sticky] [data-cb-msg]');
    all('[data-cb-sel-buy]').forEach((b) => b.addEventListener('click', () => {
      // 各単品に「購入方法：SELECTセット」を付ける（カート・注文・確認メールで SELECT 経由と分かるように）
      const lines = items.filter((el) => state.get(el) > 0).map((el) => ({ id: Number(el.dataset.variant), quantity: state.get(el), properties: { 購入方法: 'SELECTセット' } }));
      if (!lines.length) return;
      all('[data-cb-sel-buy]').forEach((x) => { x.disabled = true; });
      addToCart(lines, msgEl).catch(render);
    }));

    render();
  };

  /* 任意入力（名入れ・メッセージ）が空のときは注文に空の項目を残さない */
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-cb-form')) return;
    form.querySelectorAll('input[name^="properties"], textarea[name^="properties"]').forEach((el) => { el.disabled = el.value.trim() === ''; });
  }, true);

  const boot = () => {
    document.querySelectorAll('[data-cb-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-cb-qtybox]').forEach(initQty);
    document.querySelectorAll('[data-cb-main]').forEach(initSticky);
    document.querySelectorAll('[data-cb-beer]').forEach(initBeer);
    document.querySelectorAll('[data-cb-select]').forEach(initSelect);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
